import * as GroupType from 'constants/GroupType';
import * as Period from 'constants/Period';

const BOXING_SCORE_MAP = {};
BOXING_SCORE_MAP[Period.NOT_STARTED] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_FIRST] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_SECOND] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_THIRD] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_FOURTH] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_FIFTH] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_SIXTH] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_SEVENTH] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_EIGHTH] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_NINTH] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_TENTH] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_ELEVENTH] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.ROUND_TWELFTH] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

BOXING_SCORE_MAP[Period.FINISHED] = {
    [GroupType.DEFAULT_GROUP]: {
        period_info: true
    }
};

export default BOXING_SCORE_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Boxing/ScoreMap.js